import SEO from '../components/SEO';
import PageHero from '../components/PageHero';
import ProjectsSection from '../sections/Projects';
import Contact from '../sections/Contact';

export default function Projects() {
  return (
    <>
      <SEO
        title="Software Development Portfolio & Case Studies | Farwings Tech Solutions"
        description="Explore our portfolio of custom software, SaaS platforms, and mobile apps built for innovative businesses worldwide."
        keywords="Portfolio, Case Studies, Web Development Projects, Mobile App Projects"
        breadcrumbs={[
          { name: 'Home', path: '/' },
          { name: 'Projects', path: '/projects' },
        ]}
      />
      <PageHero title="Our clients">Real businesses, real problems, solved.</PageHero>
      <ProjectsSection />
      <Contact />
    </>
  );
}
